import React from 'react';

import { useUIMode } from '../contexts/UIModeContext';
import { useUIStyle } from '../contexts/UIStyleContext';
import { ReactComponent as HeyloginLogoLightMode } from '../images/heylogin_logo.svg';
import { ReactComponent as HeyloginLogoDarkMode } from '../images/heylogin_logo_dark_mode.svg';

interface Props {
  className?: string;
}

export default function HeyloginLogo({ className }: Props) {
  const uiStyle = useUIStyle();
  const uiMode = useUIMode();

  return uiStyle === 'highlight' || uiMode === 'dark' ?
      <HeyloginLogoDarkMode role="img" aria-label="heylogin" className={className} />
    : <HeyloginLogoLightMode role="img" aria-label="heylogin" className={className} />;
}
